import type {QueuedMessage} from '../../../agentChat/queue';

export interface QueueRowRecall {
  imageCount: number;
  canRecall: boolean;
}

/**
 * queueRowRecall derives a queued row's attachment count and whether recall is
 * offered. Recall is hidden for a missing or mid-send item.
 */
export function queueRowRecall(
  item: QueuedMessage | undefined
): QueueRowRecall {
  const imageCount = item?.content.filter(p => p.type === 'image').length ?? 0;
  const canRecall = item != null && !item.draining;
  return {imageCount, canRecall};
}
